module.exports = __webpack_public_path__ + "img/47.38716d1b.jpg";